import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { IconButton, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";
export default function PopoverInfo({ message, children }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useTranslation();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Stack direction={"row"} spacing={2} alignItems={"center"}>
      {children}
      <IconButton
        size="small"
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        title={t("MoreInfo")}
      >
        <FaInfoCircle />{" "}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 2 }}>{t(message)}</Typography>
      </Popover>
    </Stack>
  );
}
